/* eslint-disable no-plusplus */
function createShiftArr() {
  const space = '    ';

  const shift = ['\n']; // array of shifts
  for (let ix = 0; ix < 100; ix++) {
    shift.push(shift[ix] + space);
  }
  return shift;
}

export function minifyCode(cssString: string) {
  return cssString
    .split(/\n/)
    .map((n) => n.trim())
    .join('');
  // return cssString.replace(/\n/g, '');
}

export function prettifyHTML(html: string) {
  // const tab = '\t';
  const tab = '  ';
  let result = '';
  let indent = '';

  html.split(/>\s*</).forEach((element) => {
    if (element.match(/^\/\w/)) {
      indent = indent.substring(tab.length);
    }

    result += `${indent}<${element}>\r\n`;

    if (element.match(/^<?\w[^>]*[^/]$/) && !element.startsWith('input')) {
      indent += tab;
    }
  });

  return result.substring(1, result.length - 3);
}

export const prettifyCSS = (text: string) => {
  const ar = text
    .replace(/\s{1,}/g, ' ')
    .replace(/\{/g, '{~::~')
    .replace(/\}/g, '~::~}~::~')
    .replace(/;/g, ';~::~')
    .replace(/\/\*/g, '~::~/*')
    .replace(/\*\//g, '*/~::~')
    .replace(/~::~\s{0,}~::~/g, '~::~')
    .split('~::~');
  const len = ar.length;
  let deep = 0;
  let str = '';
  let ix = 0;
  const shift = createShiftArr();

  for (ix = 0; ix < len; ix++) {
    if (/\{/.exec(ar[ix])) {
      str += shift[deep++] + ar[ix];
    } else if (/\}/.exec(ar[ix])) {
      str += shift[--deep] + ar[ix];
    } else if (/\*\\/.exec(ar[ix])) {
      str += shift[deep] + ar[ix];
    } else {
      str += shift[deep] + ar[ix];
    }
  }
  return str.replace(/^\n{1,}/, '');
};

export const filterSrcMap = (cssString: string) =>
  cssString.replace(/\/\*#.*\*\//g, '');
